import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchChampionship } from 'modules/championship/store/championship/actions';

import { allIdsChampionshipsDataSelector } from 'modules/championship/store/championship/selectors';
import { useChampionship } from './use-championship';

export const useChampionshipFetch = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { isLoading } = useChampionship(Number(id));
  const allLoadedChampionshipsIds = useSelector(allIdsChampionshipsDataSelector);
  const championshipId = id ? parseInt(id) : null;

  useEffect(() => {
    if (!isLoading && championshipId && !allLoadedChampionshipsIds.includes(championshipId)) {
      dispatch(fetchChampionship(championshipId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [championshipId]);
};
